import { Observable } from 'rxjs'
import { coreApiUrl, httpPostRaw, lanternUrl } from 'services/httpService'

export default class AuthClient {
    public static login(request: any): Observable<any> {
        return httpPostRaw<any>(lanternUrl('/signin'), request)
    }

    // core-frontend links to /sso-login/ with a one-time login code instead of the session key
    // (core-backend docs/auth_refactor.md §11). It works once, within 60 seconds, and only for this app.
    public static redeemLoginCode(code: string): Observable<{ sessionKey: string }> {
        return httpPostRaw<{ sessionKey: string }>(coreApiUrl('/v2/login-codes/redeem'), { code, audience: 'billing' })
    }
}
